// extracted by mini-css-extract-plugin
export default {"card":"Card_card__coHE9","cardTitle":"Card_cardTitle__Ph3yk","social":"Card_social__qdG18","cardButton":"Card_cardButton__UC2ey"};